import styled from "styled-components";

export const DetailPageElement = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
